import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Resolves the display title of a competence.
 *
 * Prefers the title stored inside the spider_web entry (title_nl / title_en),
 * which comes from the questionnaire JSON at answer time. Falls back to legacy
 * i18n keys so profiles created before the ABM change keep rendering.
 *
 * Usage:
 *   {{ competence | competenceTitle }}          -> uses 'dh_profile:competences:<id>'
 *   {{ competence | competenceTitle:'multi' }}  -> uses 'dh_profile:competences:multi:<id>'
 */
@Pipe({ name: 'competenceTitle', pure: false })
export class CompetenceTitlePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(entry: any, variant: 'default' | 'multi' = 'default'): string {
    if (!entry) return '';

    const lang =
      this.translate.currentLang || this.translate.getDefaultLang() || 'nl';

    if (lang === 'en' && entry.title_en) return entry.title_en;
    if (entry.title_nl) return entry.title_nl;
    if (entry.title_en) return entry.title_en;

    const key =
      variant === 'multi'
        ? 'dh_profile:competences:multi:' + entry.competence_id
        : 'dh_profile:competences:' + entry.competence_id;
    return this.translate.instant(key);
  }
}
